import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getHeader } from '@/utils/storage';

const baseUrl = envConfig.storageServiceUrl + '/cloud-storage/admin/application/config/';

function baseApi() {

    function insertConfig(data, appId) {
        return Post(baseUrl + 'insertConfig', data, getHeader(appId));
    }

    function updateConfig(data, appId) {
        return Post(baseUrl + 'updateConfig', data, getHeader(appId));
    }

    function deleteConfig(data, appId) {
        return Post(baseUrl + 'deleteConfig', data, getHeader(appId));
    }

    function queryConfigList(appId, data = {}) {
        return Post(baseUrl + 'queryConfigList', data, getHeader(appId));
    }


    return {
        insertConfig, deleteConfig, queryConfigList, updateConfig
    };
}

export const applicationConfigApi = baseApi();
